import React, { FC, ReactNode } from 'react'
import { makeStyles } from 'transfix-ui/core'
import Typography from 'transfix-ui/core/Typography'

export interface IDisplayLabelProps {
  /**
   * @example 'Total Miles'
   */
  children: ReactNode | undefined
}

const useDisplayLabelStyles = makeStyles(() => ({
  root: {
    fontWeight: 'bold',
    marginBottom: '1px',
  },
}))

export const DisplayLabel: FC<IDisplayLabelProps> = ({ children }) => {
  const classes = useDisplayLabelStyles()
  return (
    <Typography
      variant='subtitle2'
      data-test='DisplayLabel'
      component='div'
      className={classes.root}>
      {children}
    </Typography>
  )
}

export default DisplayLabel
